// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__AiSgF","footer":"Layout_footer__WeXWe"};